import { useGetResults } from './getResults';

export function useLastRecordingLanguage(medatixxPatientId: string | undefined) {
  const { data, isFetched, isLoadingError, error } = useGetResults(
    { medatixxPatientId, page_size: 1 },
    { enabled: !!medatixxPatientId }
  );

  return { language: data?.pages[0]?.results[0]?.language, isFetched, isLoadingError, error };
}
